const PackagesData = [
    {
        plan: 'Social Media Management',
        package_title: 'Starter Package',
        package_desc: 'Focuses on foundational social media management elements.',
        includes_list: [
            { title: 'Basic Meta Ads', },
            { title: '1 Free Photoshoot: 8 Videos & 6 Photos', },
            { title: 'Reviews', },
            { title: 'Stories', },
            { title: 'Customer Management'}   
        ]
    },
    {
        plan: 'Social Media Management',
        package_title: 'Pro Package',
        package_desc: 'Adds more advanced features and enhanced media.',
        includes_list: [
            { title: 'Everything in Starter Package', },  
            { title: 'Enhanced Photoshoot: 10 Videos & 8 Photos', },  
            { title: 'Google Ads', },     
        ]
    },
    {
        plan: 'Social Media Management',
        package_title: 'Elite Package',
        package_desc: 'Offers the most comprehensive service with influencer management and premium media.',
        includes_list: [
            { title: 'Everything in Pro Package' },
            { title: 'Influencer Management', },
            { title: 'Premium Photoshoot: 13 Videos & 10 Photos', }   
        ]
    },
    {
        plan: 'Social Media Boosting',
        package_title: 'Boost & Shine',
        package_desc: '',
        includes_list: [
            { title: '3-Month Duration',},
            { title: 'Professional Photoshoot', },
            { title: 'Social Media Boosting', },
            { title: 'Influencer Management', },
            { title: 'Organic & Paid Reach Strategies', },   
        ]
    },
    {
        plan: 'SEO',
        package_title: 'Essential SEO Package',
        package_desc: '',
        includes_list: [
            {
                title: 'Keyword Research',
                text: 'Identification of relevant keywords for your business' 
            },
            {
                title: 'On-Page Optimization',
                text: 'Optimization of meta tags, headings, and content'
            },
            {
                title: 'Technical SEO',
                text: 'Site audit and fixes for technical issues (e.g., site speed, mobile-friendliness)'
            },
            {
                title: 'Backlink Building',
                text: 'Strategy for acquiring high-quality backlinks'
            },
            {
                title: 'Monthly Reporting',
                text: 'Performance tracking and progress reports'
            }, 
        ]
    },
    {
        plan: 'Photography',
        package_title: 'Visual Impact Package',
        package_desc: '',
        includes_list: [
            { title: 'Brand Shoot', },
            { title: 'Coverage of All Types of Products or Services', },
            { title: '3 Videos', },
            { title: '10 Photos per Product', }   
        ]
    },
    {
        plan: 'E-commerce Photography',
        package_title: 'E-Com Visuals Package',
        package_desc: '',
        includes_list: [
            { title: 'Product Photoshoot', },
            { title: 'Platform-Specific Requirements for Amazon, Noon, Shopify, etc.', },
            { title: '3 Videos', },
            { title: '5 Photos per Product', } 
        ]
    },
    {
        plan: 'E-commerce Management',
        package_title: 'E-Com Success Package',
        package_desc: '',
        includes_list: [
            { title: 'Management of Amazon, Noon, Shopify, etc.', },
            { title: 'Product Hunting', },
            { title: 'Product Sourcing', },
            { title: 'Supplier Management', },
            { title: 'Branding', },
            { title: 'Advertisement' }   
        ]
    },
    {
        plan: 'Personal Branding & Promotion',
        package_title: 'Executive Presence Package',
        package_desc: '',
        includes_list: [
            { title: 'Personal Branding Strategy', },
            { title: 'Social Media Management', },
            { title: 'Podcast Shoot', },
            { title: 'LinkedIn Management', },
            { title: 'Content Creation and Management', }
        ]
    },
    {
        plan: 'Content Creation',
        package_title: 'Creative Vision Package',
        package_desc: '',
        includes_list: [
            { title: 'Custom Content Creation Tailored to Brand or Business', },
            { title: 'Storyline Development', },
            { title: 'Professional Photoshoot', },
            { title: 'Script Writing', } 
        ]
    },
    {
        plan: 'UI/UX Design',
        package_title: 'Comprehensive UI/UX Design Package',
        package_desc: '',
        includes_list: [
            {
                title: 'Web UI/UX Design',
                text: 'Design for responsive web interfaces',
            },
            {
                title: 'Mobile App UI/UX Design',
                text: 'Design for mobile applications (iOS and Android)',
            },
            {
                title: 'Wireframing & Prototyping',
                text: 'Creation of wireframes and interactive prototypes',
            },
            {
                title: 'Usability Testing',
                text: 'Evaluating design effectiveness through user testing',
            },
        ]
    },
    {
        plan: 'Web Design',
        package_title: 'Essential Web Design Package',
        package_desc: '',
        includes_list: [
            {
                title: 'Custom Web Design',
                text: 'Tailored to fit your brand’s identity',
            },
            {
                title: 'Responsive Design',
                text: 'Optimized for desktop, tablet, and mobile devices',
            },
            {
                title: 'UI/UX Design',
                text: 'User-friendly interface and experience',
            },
            {
                title: 'Homepage Design',
                text: 'Engaging and professional main page',
            },
            {
                title: 'Basic SEO Setup',
                text: 'Essential optimization for search engines',
            },
        ]
    },
    {
        plan: 'Ads and Social Media Design',
        package_title: 'Engaging Ads & Social Media Design Package',
        package_desc: '',
        includes_list: [
            {
                title: 'Custom Ad Design',
                text: 'Tailored graphics for ads',
            },
            {
                title: 'Social Media Visuals',
                text: 'Design for posts and stories',
            },
            {
                title: 'Branded Templates',
                text: 'Consistent design for recurring content',
            },
        ]
    },
];
export default PackagesData;
